import CustomTextarea from "../../../components/Textarea/index.js";
import { AISystemContext } from "../../../entities/useCaseChat/UseCase";
import type { ChangeEvent } from 'react';
import { CtxGrid, CtxField } from "../../../components/UseCaseContextField/index.js";

interface SystemFormProps {
    formValues: AISystemContext;
    onInputChange: (field: keyof AISystemContext, value: string) => void;
    viewOnly?: boolean
}

const SystemForm: React.FC<SystemFormProps> = ({
    formValues,
    onInputChange,
    viewOnly = true
}) => {
    if (viewOnly) {
        return (
            <CtxGrid>
                <CtxField label="AI Capabilities" value={formValues.aiCapabilities} placeholder="No AI capabilities provided" full />
                <CtxField label="AI Models" value={formValues.aiModels} placeholder="No AI models provided" full />
                <CtxField label="Software Components" value={formValues.softwareComponents} placeholder="No software components provided" full />
                <CtxField label="Deployment Environment" value={formValues.deploymentEnvironment} placeholder="No deployment environment provided" full />
            </CtxGrid>
        );
    }
    return (
        <div className="space-y-6 pb-2">
            <CustomTextarea
                variant="plain"
                label="AI Capabilities"
                value={formValues.aiCapabilities}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("aiCapabilities", e)
                    } else {
                        onInputChange("aiCapabilities", e.target.value)
                    }
                }}
                placeholder="Enter AI capabilities"
            />
            <CustomTextarea
                variant="plain"
                label="AI Models"
                value={formValues.aiModels}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("aiModels", e)
                    } else {
                        onInputChange("aiModels", e.target.value)
                    }
                }}
                placeholder="Enter AI models"
            />
            <CustomTextarea
                variant="plain"
                label="Software Components"
                value={formValues.softwareComponents}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("softwareComponents", e)
                    } else {
                        onInputChange("softwareComponents", e.target.value)
                    }
                }}
                placeholder="Enter software components"
            />
            <CustomTextarea
                variant="plain"
                label="Deployment Environment"
                value={formValues.deploymentEnvironment}
                onChange={(e: string | ChangeEvent<HTMLTextAreaElement>) => {
                    if (typeof e === 'string') {
                        onInputChange("deploymentEnvironment", e)
                    } else {
                        onInputChange("deploymentEnvironment", e.target.value)
                    }
                }}
                placeholder="Enter deployment environment"
            />
        </div>
    );
};
export default SystemForm;